import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {addDoc, collection, deleteDoc, doc, getDoc, setDoc, Timestamp} from "firebase/firestore";
import {Firestore} from "../../../utils/Firebase";
import {Button, Container, Grid, TextField} from "@mui/material";
import * as React from "react";
import {DashboardMenuContainer} from "../Dashboard/DashboardMenu";

const Job = () => {
    const [jobData, setJobData] = useState({
        dateTill: new Timestamp(0, 0),
        description: "",
        jobProvider: "",
        jobProviderPhone: "",
        location: "",
        logo: "",
        name: "",
        reward: "",
    });

    const navigate = useNavigate();
    const {id} = useParams();

    useEffect(() => {
        getDoc(doc(Firestore, "jobOffers", id))
            .then(d => {
                if (d.exists()) {
                    const data = d.data();
                    setJobData({
                        ...data,
                        dateTill: new Timestamp(data.dateTill.seconds, data.dateTill.nanoseconds)
                    });
                }
            })
            .catch(e => {
                console.error(e);
            });

    }, [id]);

    const handleInputChange = (event) => {
        const target = event.target;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        if (target.type === "number") {
            value = parseFloat(value);
        }
        const name = target.name;
        console.log(jobData);
        setJobData({
            ...jobData,
            [name]: value
        });
    }

    const sendFormData = (e) => {
        e.preventDefault();
        if (id !== "new") {
            setDoc(doc(Firestore, "jobOffers", id), jobData)
                .then(doc => {
                    navigate('/jobs');
                });
        }
        else {
            addDoc(collection(Firestore, "jobOffers"), jobData)
                .then(doc => {
                    navigate('/jobs');
                });
        }
    }

    const deleteThisDoc = () => {
        deleteDoc(doc(Firestore, "jobOffers", id))
            .then(doc => {
                navigate('/jobs');
            });
    }

    return(
        DashboardMenuContainer(
            <Container maxWidth="md">
                <h1>Úprava pracovnej ponuky</h1>
                <form onSubmit={sendFormData}>
                    <Grid container spacing={4}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="name"
                                name="name"
                                label="Názov ponuky"
                                value={jobData.name}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="jobProvider"
                                name="jobProvider"
                                label="Poskytovateľ práce"
                                value={jobData.jobProvider}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="jobProviderPhone"
                                name="jobProviderPhone"
                                label="Tel. číslo na poskytovateľa"
                                value={jobData.jobProviderPhone}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="reward"
                                name="reward"
                                label="Odmena"
                                value={jobData.reward}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="location"
                                name="location"
                                label="Adresa"
                                value={jobData.location}
                                onChange={handleInputChange}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="dateTill"
                                name="dateTill"
                                label="Dostupnosť do"
                                type="date"
                                value={jobData.dateTill.toDate().toISOString().replace(/T.*/,'')}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const seconds = new Date(value).getTime()/1000;
                                    setJobData({
                                        ...jobData,
                                        dateTill: new Timestamp(seconds, 0)
                                    });
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                required
                                id="logo"
                                name="logo"
                                label="Link na logo"
                                value={jobData.logo}
                                onChange={handleInputChange}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                required
                                multiline
                                minRows={5}
                                id="description"
                                name="description"
                                label="Popis ponuky"
                                value={jobData.description}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button type="submit" variant="contained">{id === "new" ? "Pridať" : "Upraviť"}</Button>
                        </Grid>
                        {
                            id !== "new" &&
                            <Grid item xs={12}>
                                <Button variant="contained" color='error' onClick={deleteThisDoc}>Vymazať</Button>
                            </Grid>
                        }
                    </Grid>
                </form>
            </Container>
    ))

}

export default Job;
